import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "bbf_cart";

export const CartProvider = ({ children }) => {
  const [state, setState] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || '{"brand":null,"items":[]}'); }
    catch { return { brand: null, items: [] }; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(state)); }, [state]);

  /** Ensure the cart belongs to the active brand. Wipes items if brand changes. */
  const ensureBrand = (brandKey) => {
    setState((s) => (s.brand && s.brand !== brandKey ? { brand: brandKey, items: [] } : { brand: brandKey, items: s.items }));
  };

  const add = (product, qty = 1) => {
    setState((s) => {
      const found = s.items.find((p) => p.product_id === product.id);
      const items = found
        ? s.items.map((p) => (p.product_id === product.id ? { ...p, quantity: p.quantity + qty } : p))
        : [...s.items, {
            product_id: product.id, name: product.name, price: product.price,
            unit: product.unit, image_url: product.image_url, quantity: qty,
          }];
      return { ...s, items };
    });
  };

  const updateQty = (product_id, quantity) => {
    if (quantity <= 0) return remove(product_id);
    setState((s) => ({ ...s, items: s.items.map((p) => p.product_id === product_id ? { ...p, quantity } : p) }));
  };

  const merge = (incoming) => {
    setState((s) => {
      const map = new Map(s.items.map((p) => [p.product_id, { ...p }]));
      for (const it of incoming) {
        const found = map.get(it.product_id);
        if (found) found.quantity += it.quantity;
        else map.set(it.product_id, { ...it });
      }
      return { ...s, items: Array.from(map.values()) };
    });
  };

  const remove = (product_id) => setState((s) => ({ ...s, items: s.items.filter((p) => p.product_id !== product_id) }));
  const clear = () => setState((s) => ({ ...s, items: [] }));

  const items = state.items;
  const subtotal = items.reduce((sum, p) => sum + p.price * p.quantity, 0);
  const count = items.reduce((sum, p) => sum + p.quantity, 0);

  return (
    <CartContext.Provider value={{ items, brand: state.brand, ensureBrand, add, merge, remove, updateQty, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
